var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper pa-4"},[_c('h1',{staticClass:"d-flex mb-2"},[_c('v-icon',[_vm._v("mdi-horse-variant-fast")]),_c('VSpacer'),_c('v-btn',{on:{"click":_vm.fullscreen}},[_vm._v(" 全屏 ")])],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative full-bleed"},[_c('canvas',{staticStyle:{"border":"1px solid","max-height":"65vh","width":"100%"},attrs:{"id":"c3"}})])
}]

export { render, staticRenderFns }